import React, { useEffect } from 'react'
import { useAtSize } from '@fs/zion-ui'
import { useDSCDispatch, useDSCState } from '../../../state/DSCStore'
import useDSApplicationMode from '../../hooks/useDSApplicationMode'
import StationMenu from '../StationMenu/StationMenu'
import { useCorrections } from '../../../aam/AppAam/hooks/hooks'

const stationModeConfig = {
  header: { header: false },
  footer: {
    footer: false,
  },
  appLayout: {
    fullWidth: true,
  },
}

export default function ConditionalHeader({ activeExperienceId }) {
  const appMode = useDSApplicationMode()
  const isCorrections = useCorrections()
  const DSCDispatch = useDSCDispatch()
  const dscState = useDSCState()
  const atSize = useAtSize()
  const isMobile = atSize({
    default: true,
    xl: false,
  })

  useEffect(() => {
    if (
      (appMode === 'STATION' || appMode === 'KIOSK' || appMode === 'STAND_ALONE' || appMode === 'CONTROLLER') &&
      !dscState.hasSetToStationOrKiosk
    ) {
      DSCDispatch({
        type: 'SET_STATION_MODE',
        data: { ...stationModeConfig },
      })
    }
  }, [DSCDispatch, appMode, dscState.hasSetToStationOrKiosk])

  useEffect(() => {
    if ((appMode === 'STAND_ALONE' || isCorrections) && dscState.header === null) {
      const hfConfig = {
        header: { header: false },
        footer: {
          footer: false,
        },
        appLayout: {
          fullWidth: true,
        },
      }

      DSCDispatch({
        type: 'SET_HEADER_FOOTER',
        data: hfConfig,
      })
    }
  })

  useEffect(() => {
    if (activeExperienceId === 'explore' && appMode === 'WEB') {
      const hfConfig = {
        header: isMobile
          ? {
              header: false,
            }
          : null,
        footer: {
          footer: false,
        },
        appLayout: {
          fullWidth: true,
        },
      }

      DSCDispatch({
        type: 'SET_HEADER_FOOTER',
        data: { ...hfConfig },
      })
    }

    if (activeExperienceId === 'relativeFinder' && appMode === 'WEB') {
      DSCDispatch({
        type: 'SET_APPLAYOUT',
        data: {
          appLayout: {
            fullWidth: false,
          },
        },
      })
    }
  }, [DSCDispatch, activeExperienceId, appMode, isMobile])

  if (appMode === 'STATION') {
    const experienceIdForStation = activeExperienceId !== 'famous' ? activeExperienceId : 'relativeFinder'
    return (
      <StationMenu
        activeExperienceId={experienceIdForStation}
        isAuthenticated={dscState?.nonstandardUser?.authenticated}
      />
    )
  }
  return null
}
